const plansIds = [
  'prod_RbQPCD1jsav7tU',
  'prod_RbQQdSq6xwy0WN',
  'prod_RbQRjlXFbt6LFm',
];

export const plans = {
  SINGLE_DISPATCH: 'prod_RbQPCD1jsav7tU',
  MULTI_DISPATCH: 'prod_RbQQdSq6xwy0WN',
  AI_DISPATCH: 'prod_RbQRjlXFbt6LFm',
};
export default plansIds;
